import React from 'react';

const Map = () => {
  return (
    <section id="location" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center">
          <span className="text-brand-black">زوروا</span>{" "}
          <span className="text-brand-pink">متجرنا</span>
        </h2>
        
        <div className="rounded-lg overflow-hidden shadow-md h-[400px]">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.6663146761894!2d44.198455700000004!3d15.340358799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1603db3bae7425ad%3A0xc573f9773852f348!2z2LnYsdmI2LPYqSDYudiv2YY!5e0!3m2!1sen!2sde!4v1745009694049!5m2!1sen!2sde"
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="موقع المتجر"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Map;
